export default {
  chatBaseUrl: state => {
    return state.chatUrl;
  },
  getCrmTemplate: state => id => {
    let template = null;

    if (id) {
      template = state.crmTemplates.find(template => template.id === id);
    } else {
      template = state.crmTemplates ? state.crmTemplates[0] : null;
    }

    if (template) {
      return {
        ...template,
        displayTemplateFields: template.displayTemplateFields
          .filter(template => template.visible)
          .sort((tA, tB) => tA.order - tB.order)
      };
    } else {
      return template;
    }
  }
};
